'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'gas-pump';
var width = 512;
var height = 512;
var aliases = [9981];
var unicode = 'f52f';
var svgPathData = 'M256 48c8.8 0 16 7.2 16 16l0 128-192 0 0-128c0-8.8 7.2-16 16-16l160 0zm16 192l0 224-192 0 0-224 192 0zM32 64l0 401.4c-9.3 3.3-16 12.2-16 22.6 0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24 0-10.5-6.7-19.3-16-22.6l0-161.4 8 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-219.6c0-13.9-5.2-27.4-14.6-37.7L425.8 39.9c-8.9-9.8-24.1-10.5-33.9-1.6s-10.5 24.1-1.6 33.9l25.8 28.3 0 59.5c0 29.8 20.4 54.9 48 62l0 154c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-8 0 0-192c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGasPump = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;